import { create } from 'zustand';

import { API, getRequest } from '@/api/api.ts';
import type { User, UsersResponse } from '@/store/users/users.dto.ts';

type UsersState = {
  users: User[];
  getUsers: () => Promise<User[]>;
};

export const useUsers = create<UsersState>((set) => ({
  users: [],
  getUsers: async () => {
    try {
      const response = await getRequest<UsersResponse>(API.AUTH, '/user?limit=100&page=1');

      const users = response.data.items;

      set({ users });

      return users;
    } catch (e) {
      console.error(e);
      return [];
    }
  },
}));
